import React from "react";
import Svg from "../Svg";
import { SvgProps } from "../types";

const Icon: React.FC<React.PropsWithChildren<SvgProps>> = (props) => {
  return (
    <Svg
      {...props} // Pass additional props to the SVG component
      width="612"
      height="792"
      viewBox="0 0 612 792"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M306 695.5C471.409 695.5 605.5 561.409 605.5 396C605.5 230.591 471.409 96.5 306 96.5C140.591 96.5 6.5 230.591 6.5 396C6.5 561.409 140.591 695.5 306 695.5Z"
        fill="#6FC7B9"
      />
      <path
        d="M394.3 566.7C391 566.7 387.9 565.4 385.5 563.1L305.8 483.4L226.1 563.1C223.8 565.4 220.6 566.7 217.3 566.7C214 566.7 210.9 565.4 208.5 563.1L193.6 548C191.3 545.7 190 542.5 190 539.2C190 535.9 191.3 532.8 193.6 530.4L273.3 450.7L183.2 360.6C178.4 355.8 178.4 347.9 183.2 343.1L297.4 228.9C299.7 226.6 302.9 225.3 306.2 225.3C309.5 225.3 312.6 226.6 315 228.9L429 342.9C431.3 345.2 432.6 348.4 432.6 351.7C432.6 355 431.3 358.1 429 360.5L338.7 450.8L418.4 530.5C420.7 532.8 422 536 422 539.3C422 542.6 420.7 545.7 418.4 548.1L403.3 563.2C400.7 565.4 397.6 566.7 394.3 566.7ZM305.9 418.1L372.3 351.7L306.1 285.5L239.7 351.9L305.9 418.1Z"
        fill="none"
      />
      <path
        d="M428.2 359.8C432.7 355.3 432.7 348.1 428.2 343.7L405 320.5L314.2 229.7C309.7 225.2 302.5 225.2 298.1 229.7L187.9 339.8L183.9 343.8C179.4 348.3 179.4 355.5 183.9 359.9L274.7 450.7L194.3 531.1C189.8 535.6 189.8 542.8 194.3 547.2L209.4 562.3C213.9 566.8 221.1 566.8 225.5 562.3L305.9 481.9L386.3 562.3C390.8 566.8 398 566.8 402.4 562.3L417.5 547.2C422 542.7 422 535.5 417.5 531.1L337.1 450.7L428.2 359.8ZM238.2 351.9L306 284.1L373.6 351.7L305.8 419.5L238.2 351.9Z"
        fill="#C7C9C9"
      />
    </Svg>
  );
};

export default Icon;
